(() => {
  const isJapanese = document.documentElement.lang
    .toLowerCase()
    .startsWith('ja');

  if (!isJapanese || window.__huigonJapaneseSearchFallback) return;

  window.__huigonJapaneseSearchFallback = true;

  const primaryLanguageSearchUrl = '/search/suggest';

  const localizedRoot = (() => {
    const shopifyRoot = window.Shopify?.routes?.root;

    if (shopifyRoot && shopifyRoot !== '/') {
      return shopifyRoot.replace(/\/$/, '');
    }

    const localeMatch = window.location.pathname.match(
      /^\/(ja(?:-[a-z]{2})?)(?:\/|$)/i
    );

    return localeMatch ? `/${localeMatch[1]}` : '/ja';
  })();

  const usePrimaryLanguageSearch = () => {
    if (!window.routes) return false;

    window.routes.predictive_search_url = primaryLanguageSearchUrl;
    return true;
  };

  if (!usePrimaryLanguageSearch()) {
    document.addEventListener(
      'DOMContentLoaded',
      usePrimaryLanguageSearch,
      { once: true }
    );
  }

  const localizeProductLink = (link) => {
    const rawHref = link.getAttribute('href');

    if (!rawHref) return;

    const url = new URL(rawHref, window.location.origin);

    if (
      url.origin !== window.location.origin ||
      !url.pathname.startsWith('/products/')
    ) {
      return;
    }

    url.pathname = `${localizedRoot}${url.pathname}`;

    link.setAttribute(
      'href',
      `${url.pathname}${url.search}${url.hash}`
    );
  };

  /*
    Predictive results are injected only while the search overlay is in use.
    Localize the selected result at activation time instead of observing every
    DOM change across the entire storefront.
  */
  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest?.(
        '[data-predictive-product-link]'
      );

      if (!link) return;

      localizeProductLink(link);
    },
    true
  );
})();
